<template>
  <z-form ref="form" tag="div">
    <a
      href="#"
      class="r-form__item__header"
      :class="`r-form__item__header--${is_collapse ? 'show' : 'hide'}`"
      @click.prevent="is_collapse = !is_collapse"
    >
      <label>{{ $t('shared.component.recipient_form.button.add_number') }}</label>
      <span>{{ $tc('shared.component.recipient_form.number_count', numbers_count) }}</span>
    </a>

    <b-collapse id="numbers" v-model="is_collapse" class="mt-3">
      <div class="row flex--center">
        <z-form-input class="col-11" :rules="{ phone: true }">
          <tel-input v-model="phone" @enter="add_phone" />
        </z-form-input>
        <icon size="18" type="md-add" color="#7f93a9" style="cursor: pointer" @click="add_phone" />
      </div>

      <div class="mt-4 bundle-list">
        <span v-for="(number, index) in value" :key="number" class="bundle bundle-blue">
          {{ number }} <i data-role="remove" @click="remove(index)">&nbsp;</i>
        </span>
      </div>
    </b-collapse>
  </z-form>
</template>

<script>
  import cloneDeep from 'lodash-es/cloneDeep';
  import TelInput from '@shared/components/input/input-phone-number';
  import AwesomePhoneNumber from 'awesome-phonenumber';

  export default {
    components: { TelInput },
    props: {
      value: {
        type: Array,
        default: () => []
      }
    },

    data: () => ({
      is_collapse: false,
      phone: ''
    }),

    computed: {
      numbers_count: function () {
        return this.value.length || 0;
      }
    },

    methods: {
      add_phone() {
        this.$refs.form.validate().then((is_valid) => {
          if (is_valid && new AwesomePhoneNumber(this.phone).isPossible()) {
            this.$emit('input', [...(this.value || []), this.phone]);
            this.phone = '';
            this.$refs.form.reset();
          }
        });
      },

      remove(index) {
        const v = cloneDeep(this.value);
        v.splice(index, 1);
        this.$emit('input', v);
      }
    }
  };
</script>